import React, { Component } from 'react';
import { isUndefined, omit, find, round, isEmpty, each } from 'lodash';

import {
    QL,
    evaluateSchema,
    evaluateExternal,
    evaluateExpression,
    evaluateURL,
    testProject,
} from '@swa_llow/pricing_engine';

class ExternalEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            original_step: null,
            step: null,
            formatted_step: null,
            editing: false,
            api: {},
        }
        this.validateStep = this.validateStep.bind(this);
        this.updateStep = this.updateStep.bind(this);
        this.editStep = this.editStep.bind(this);
        this.reHydrate = this.reHydrate.bind(this);
        this.testAPI = this.testAPI.bind(this);
    }

    async UNSAFE_componentWillMount(){
        const { step = {} } = this.props;

        let clean_step;

        if(!await this.validateStep(JSON.stringify(step), false)) {
            const base = find(testProject.steps, s => s.step === step.step);
            clean_step = {
                ...clean_step,
                ...base,
            };
        }

        clean_step = omit(step, ['id', 'step']);

        await this.setState({
            original_step: step,
            step: JSON.stringify(clean_step),
            formatted_step: JSON.stringify(clean_step, null, 4),
        });
    }

    async testAPI () {
        let { step = {} } = this.state;
        const { inputs } = this.props;

        // Create inputs for url {{}} replace
        let original = {};
        each(inputs, (input, k) => {
            original[k] = input.value;
        });

        let options;
        let format;
        let api_data;

        this.setState({
            api: {},
        })

        const start_time = window.performance.now();

        try {
            step = JSON.parse(step) || {};
            options = step.options;
            format = step.format;

            const url = evaluateURL({
                url: options.url,
                original: QL(original),
            });

            options.url = url;

        } catch(e) {
            //TODO deal with parse error
        }

        try {
            api_data = await evaluateExternal(options);
        } catch(e) {
            //TODO deal with request error
        }

        const end_time = window.performance.now();
        const time = round(end_time - start_time, 1);

        let format_data = {};
        try {
            each(format, (f, k) => {
                const { exp = '', type } = f;
                const { result: value } = evaluateExpression({
                    expression: exp,
                }, QL(api_data));
                format_data[k] = {
                    value,
                    type,
                }
            });
        } catch(e) {
            //TODO deal with format error
        }

        this.setState({
            api: {
                api_data,
                api_formatted: JSON.stringify(api_data, null, 4),
                error: null, 
                time,
                format_data,
                format_formatted: JSON.stringify(format_data, null, 4),
            }
        })
    }

    reHydrate(step) {
        const { original_step } = this.state;
        let new_step = {
            ...JSON.parse(step),
            id: original_step.id,
            step: original_step.step,
        }
        return new_step;
    }

    async validateStep(step, show_error = true) {
        const { schema } = this.props;
        this.setState({ valid: true, errors: [] });

        // For Validate JSON button
        if (!step) step = this.state.step;

        let new_step;
        try {
            new_step = this.reHydrate(step);
        } catch(e) {
            if (show_error) this.setState({ valid: false, errors: [{ message: e.message }] });
            return false;
        }
        
        const result = evaluateSchema({
            project: new_step,
            schema,
        });

        if (!result.valid) {
            if (show_error) this.setState({ valid: false, errors: result.errors });
            return false;
        }

        await this.setState({ valid: true, errors: []});
        return true;
    }

    editStep (step) {
        this.setState({ step });
    }

    async updateStep () {
        const valid = await this.validateStep();
        if(valid) {
            const { step } = this.state;
            await this.setState({
                formatted_step : JSON.stringify(JSON.parse(step), null, 4),
                editing: false,
            })
            const new_step = this.reHydrate(step);
            await this.props.overwriteStep(new_step); 
        }
    }   

    render() {
        const { 
            step,
            formatted_step,
            editing,
            errors = [],
            valid,
            api,
        } = this.state;

        const { is_approved } = this.props;

        const [error] = errors;

        if (editing) {
            return (
                <div className="common-edit-area">
                    <div className="code-block">
                        <label>Step Config (Edit)</label>
                        <textarea 
                            onChange={async(e) => {
                                await this.editStep(e.target.value);
                            }}
                            value={step.toString()}
                        />
                        {!isUndefined(valid) && valid && <button className="button tertiary small validity">VALID</button>}
                        {!isUndefined(valid) && !valid && <button className="button error small validity">INVALID</button>}
                        <button className="secondary button small" onClick={() => this.updateStep()}>Update Step</button>
                    </div>
                    {error && <p className="error-message">{error.message}</p>}
                </div>
            );
        }

        return (
            <div>
                <div className="common-edit-area">
                    <div className="code-block">
                        <label>Step Config</label>
                        <textarea 
                            onFocus={() => this.setState({ editing: true })}
                            value={formatted_step}
                        />
                        {!isUndefined(valid) && valid && <button className="button tertiary small validity">VALID</button>}
                        {!isUndefined(valid) && !valid && <button className="button error small validity">INVALID</button>}
                        <button style={{ right: '82px' }}className="secondary button small" onClick={() => navigator.clipboard.writeText(this.state.formatted_step)}>Copy to Clipboard</button>
                        {!is_approved && <button className="secondary button small" onClick={() => this.setState({ editing: true })}>Edit Step</button>}
                    </div>
                    {error && <p className="error-message">{error.message}</p>}
                </div>

                <button className="button small main" onClick={this.testAPI}>Text API</button>

                {!isEmpty(api) && 
                    <div className="common-edit-area-container" style={{marginTop: 20 }}>
                        <div className="common-edit-area">
                            <div className="code-block">
                                <label>API Response ({api.time} ms)</label>
                                <textarea 
                                    value={api.api_formatted}
                                />
                                <button style={{ right: '20px' }}className="secondary button small" onClick={() => navigator.clipboard.writeText(api.formatted)}>Copy to Clipboard</button>
                            </div>
                        </div>
                        <div className="common-edit-area">
                            <div className="code-block">
                                <label>Formatted Response</label>
                                <textarea 
                                    value={api.format_formatted}
                                />
                                <button style={{ right: '20px' }}className="secondary button small" onClick={() => navigator.clipboard.writeText(api.format_formatted)}>Copy to Clipboard</button>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

export default ExternalEdit;